<template>
  <nav class="navbar navbar-expand-lg navbar-sticky sticky py-3" :class="{ 'scrolled': props.isScrolled }">
    <div class="container-lg">
      <router-link
        class="navbar-brand logo-style"
        to="/"
        @click="$emit('homeScroll')"
      >
        <span class="text-primary">/</span>
        <span class="text-secondary">/</span>
        <span class="text-tertiary">/</span>
        nologo studios
      </router-link>

      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="offcanvas"
        data-bs-target="#offcanvasNavbar"
        aria-controls="offcanvasNavbar"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <div
        class="offcanvas offcanvas-start bg-light"
        tabindex="-1"
        id="offcanvasNavbar"
        aria-labelledby="offcanvasNavbarLabel"
      >
        <div class="offcanvas-header">
          <a
            class="offcanvas-title logo-style"
            href="/"
            @click="$emit('homeScroll')"
            id="offcanvasNavbarLabel"
          >
            <span class="text-primary">/</span>
            <span class="text-secondary">/</span>
            <span class="text-tertiary">/</span>
            nologo studios
          </a>
          <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
        </div>

        <div class="offcanvas-body">
          <ul class="navbar-nav ms-auto mb-2 mb-lg-0 align-items-center accordion">
            <!-- Reactive Accordion Items -->
            <MobileAccordionItem
              v-for="(item, index) in accordionItems"
              :key="item.id"
              :title="item.title"
              :isOpen="openIndex === index"
              @toggle="toggleAccordion(index)"
            >
              <ul class="list-unstyled">
                <li v-for="link in item.links" :key="link.to">
                  <a
                    class="nav-link"
                    :href="link.to"
                  >
                    {{ link.text }}
                  </a>
                </li>
                <li v-if="item.viewAllLink">
                  <a class="nav-link" :href="item.viewAllLink">
                    View all
                  </a>
                </li>
              </ul>
            </MobileAccordionItem>

            <!-- Static Links -->
            <li class="nav-item"><a class="nav-link" href="/about-us">About</a></li>
            <!-- <li class="nav-item"><a class="nav-link" href="/case-studies">Case Studies</a></li> -->
            <li class="nav-item"><a class="nav-link" href="/careers">Careers</a></li>

            <li class="nav-item">
              <a href="/contact" class="btn btn-primary text-white text-center py-2 px-4">
                Get in touch
              </a>
            </li>
          </ul>
        </div>
        <hr class="mt-0"/>
        <div class="nav-item flex justify-content-center py-2 text-center">
          <a href="https://za.linkedin.com/company/nologo-studios" target="_blank"><i class="fa-brands fa-linkedin-in h1 mx-2"></i></a>
          <a href="https://www.facebook.com/nologostudios/" target="_blank"><i class="fa-brands fa-facebook h1 mx-2"></i></a>
          <a href="tel:+27312660245"><i class="fa-solid fa-phone h2 fw-bold mx-2"></i></a>
          <a href="mailto:info@nologostudios.com"><i class="fas fa-envelope h2 fw-bold mx-2"></i></a>
        </div>
      </div>
    </div>
  </nav>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from 'vue';
import { Offcanvas } from 'bootstrap';
import MobileAccordionItem from './MobileAccordionItem.vue';

const props = defineProps({
  isScrolled: Boolean,
  homeServices: Array,
  specialistServices: Array,
});

const emit = defineEmits(['homeScroll']);
const openIndex = ref<number | null>(null);

const accordionItems = computed(() => [
  {
    id: 'what-we-do',
    title: 'Our services',
    links: props.homeServices?.map((s: any) => ({
      text: s.displayText,
      to: s.path
    })) || [],
    //viewAllLink: '/services'
  },
  {
    id: 'specialist-divisions',
    title: 'Specialist Divisions',
    links: props.specialistServices?.map((s: any) => ({
      text: s.displayText,
      to: s.path
    })) || [],
    //viewAllLink: '/specialist-divisions'
  }
]);

function toggleAccordion(index: number) {
  openIndex.value = openIndex.value === index ? null : index;
}

onMounted(() => {
  const offcanvasElement = document.getElementById('offcanvasNavbar');
  if (offcanvasElement) {
    new Offcanvas(offcanvasElement);
  }
});
</script>

<style scoped lang="scss">
@import "@/scss/variables.scss";

.navbar-toggler {
  border: none;
}

.navbar-toggler:focus {
  box-shadow: none;
}

.offcanvas {
  transition: transform 0.3s ease-in-out;
  height: 100vh;
  background-color: #fcfcff;
}

.offcanvas-header .offcanvas-title {
  color: #0d1013;
  text-decoration: none;
  font-family: "Segoe UI Variable Display", sans-serif;
  font-weight: 350;
  font-size: 1.6rem;
}

.offcanvas-body {
  padding: 0;
}

#offcanvasNavbar .navbar-nav {
  flex-direction: column;
  width: 100%;
}

#offcanvasNavbar .nav-item {
  width: 100%;
}

#offcanvasNavbar .nav-item:last-child {
  border-bottom: none;
}

#offcanvasNavbar .nav-link,
#offcanvasNavbar .btn {
  padding: 1rem;
  text-align: left;
  color: #333;
}

#offcanvasNavbar .nav-item .btn {
  width: calc(100% - 2rem);
  margin: 1rem;
}
</style>